import ToastContainer from "./Utils/ToastContainer";
import PageNotFound404 from "./Errors/PageNotFound404";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Base from "./Pages/Base";
import "./App.css";
import Home from "./Pages/Home";
import ThemeScriptLoader from "./Utils/ThemeScriptLoader";
import ScrollToTop from "./Utils/ScrollToTop";
import Property from "./Pages/Property";
import PropertyDetail from "./Pages/PropertyDetail";
import Login from "./Pages/Login";
import Registration from "./Pages/Registration";
import About from "./Pages/About";
import Services from "./Pages/Services";
import Team from "./Pages/Team";
import TeamDetails from "./Pages/TeamDetails";
import Blogs from "./Pages/Blogs";
import BlogsDetails from "./Pages/BlogsDetails";
import AgentDashboard from "./Pages/agentDashboard/AgentDashboard";
import Contact from "./Pages/Contact";
import PropertyManagementServiceDetails from "./Pages/PropertyManagementServiceDetails";
import RealStateBrokerageServiceDetails from "./Pages/RealStateBrokerageServiceDetails";
import RealStateMarketingServiceDetail from "./Pages/RealStateMarketingServiceDetail";
import MaintenanceAndOperation from "./Pages/MaintenanceAndOperation";
import PropertyDevelopmentServiceDetails from "./Pages/PropertyDevelopmentServiceDetails";
import Gallery from "./Pages/Gallery";
import DiyarulKhuzamaLanding from "./Pages/DiyarulKhuzamaLanding";
 

function App() {
  return (
    <>
      <BrowserRouter>
        <ThemeScriptLoader />
        <ScrollToTop />

        {/* ToastContainer */}
        <ToastContainer />

        {/* Routes */}
        <Routes>
          <Route path='/' element={<Base><Home/></Base>} />
          <Route path='/property' element={<Base><Property/></Base>} />
          <Route path='/property/:id' element={<Base><PropertyDetail/></Base>} />
          <Route path='/login' element={<Base><Login/></Base>} />
          <Route path='/register' element={<Base><Registration/></Base>} />
          <Route path='/about' element={<Base><About/></Base>} />
          <Route path='/services' element={<Base><Services/></Base>} />
          <Route path='/service-details/:id' element={<Navigate to="/services" replace />} />
          <Route path='/team' element={<Base><Team/></Base>} />
          <Route path='/team-details/:id' element={<Base><TeamDetails/></Base>} />
          <Route path='/blogs' element={<Base><Blogs/></Base>} />
          <Route path='/blogs-details/:id' element={<Base><BlogsDetails/></Base>} />
          <Route path='/agent-dashboard' element={<Base><AgentDashboard/></Base>} />
          <Route path='/contact' element={<Base><Contact/></Base>} />
          <Route path='/property-details/:id' element={<Base><PropertyDetail/></Base>} />
          <Route path='/property-management-saudi-arabia' element={<Base><PropertyManagementServiceDetails/></Base>} />
          <Route path='/real-estate-brokerage-saudi-arabia' element={<Base><RealStateBrokerageServiceDetails/></Base>} />
          <Route path='/real-estate-marketing-saudi-arabia' element={<Base><RealStateMarketingServiceDetail/></Base>} />
          <Route path='/property-maintenance-operations-saudi-arabia' element={<Base><MaintenanceAndOperation/></Base>} />
          <Route path='/property-development-saudi-arabia' element={<Base><PropertyDevelopmentServiceDetails/></Base>} />
          <Route path='/property-management-service-details/:id' element={<Navigate to="/property-management-saudi-arabia" replace />} />
          <Route path='/real-state-brokerage-service-details/:id' element={<Navigate to="/real-estate-brokerage-saudi-arabia" replace />} />
          <Route path='/real-state-marketing-service-details/:id' element={<Navigate to="/real-estate-marketing-saudi-arabia" replace />} />
          <Route path='/maintenance-and-operation-service-details/:id' element={<Navigate to="/property-maintenance-operations-saudi-arabia" replace />} />
          <Route path='/property-development-service-details/:id' element={<Navigate to="/property-development-saudi-arabia" replace />} />
          <Route path='/gallery' element={<Base><Gallery/></Base>} />
          <Route path='/diyarul-khuzama' element={<DiyarulKhuzamaLanding />} />

          <Route path='*' element={<PageNotFound404 />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
